export default __webpack_public_path__ + "static/digital-wallet-app-development-digipay-guru-a1b72dd260843c390c1eb312b30fd397.png";